module.exports = __webpack_public_path__ + "img/down-arrow.0128d76e.svg";